import type { IconSvgObject } from './types';

const ALargeSmallIcon: IconSvgObject = [
  ["path", { d: "M2 17L4.62734 9.99376C5.41378 7.89659 5.807 7 6.5 7C7.193 7 7.58622 7.89659 8.37266 9.99376L11 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 17.0003L16.6123 12.3937C17.3978 10.1495 17.7905 9.02734 18.5 9.02734C19.2095 9.02734 19.6022 10.1495 20.3877 12.3937L22 17.0003", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 14H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 13H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ALargeSmallIcon;
